import { jsx } from 'panel';
import { SvgIconEl } from 'common/components/svg-icon';
export function template() {
  const {
    linkNodes
  } = this.state;

  const BreadcrumbNode = _ref => {
    let {
      node,
      idx
    } = _ref;
    return jsx("div", {
      sel: '.breadcrumb-node'
    }, !node.selected ? jsx("div", {
      sel: '.step.link',
      on: {
        click: () => this.helpers.nodeClicked(node, idx)
      }
    }, node.url ? jsx("a", {
      attrs: {
        href: node.url
      }
    }, node.label) : node.label) : jsx("div", {
      sel: '.step.selected'
    }, node.label));
  };

  return jsx("div", {
    sel: '.breadcrumbs'
  }, linkNodes.map((node, idx) => jsx(null, null, jsx(BreadcrumbNode, {
    node: node,
    idx: idx
  }), idx < linkNodes.length - 1 ? jsx(SvgIconEl, {
    attrs: {
      icon: "caret-right"
    }
  }) : null)));
}